'use client';

import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';

import { AuthQueryOptions } from '@/api';
import { GOV_CODE } from '@/app/donation/constants';
import { DONATION_ROUTES } from '@/constants';
import { useCustomRouter } from '@/hooks/useCustomRouter';

/**
 * 제주도에 기부 여부를 확인하고, 기부하지 않은 경우 리다이렉트하는 커스텀 훅
 */
export const useJejuDonationValidation = ({
  onFailed,
}: {
  onFailed: () => void;
}) => {
  const router = useCustomRouter();

  //* 제주도에 기부 여부 validation
  const { data: isDonatedToJeju } = useQuery({
    ...AuthQueryOptions['get:/wello/v2/auth/home-donation/my'](),
    select: (data) => {
      const donatedGovCodeList = data.context?.homeLoveGovCodeList ?? [];

      return donatedGovCodeList.includes(GOV_CODE.JEJU);
    },
  });

  //* 제주도에 기부하지 않은 경우 리다이렉트
  useEffect(() => {
    if (isDonatedToJeju === false) {
      onFailed();
      router.push(DONATION_ROUTES.MY_JEJU_RECOMMEND_INFO.pathname);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isDonatedToJeju, router]);

  return {
    isDonatedToJeju,
  };
};
